export const EXPERIMENT_STATUSES = {
  ACTIVE: 'active',
  COMPLETED: 'completed',
  PAUSED: 'paused',
} as const;

export type ExperimentStatus =
  (typeof EXPERIMENT_STATUSES)[keyof typeof EXPERIMENT_STATUSES];

export const GALLERY_INTERACTIONS_EXPERIMENT_KEY =
  'gallery-interaction-staging' as const;

// Experience IDs and variation IDs from the Convert dashboard:
// https://app.convert.com/accounts/10042404/projects/100416932/experiences
export const EXPERIMENTS = {
  PRICING_INSIGHTS_DEV: {
    id: '1004188956',
    name: 'Pricing insights staging',
    key: 'pricing-insights-staging',
    variations: {
      ORIGINAL: { key: 'original', id: '1004444366' },
      VARIANT: { key: 'pricing-insights-variant', id: '1004444367' },
    },
  },
  PRICING_INSIGHTS_PROD: {
    id: '1004188958',
    name: 'Pricing insights',
    key: 'pricing-insights',
    variations: {
      ORIGINAL: { key: 'original', id: '1004444370' },
      VARIANT: { key: 'pricing-insights-variant', id: '1004444371' },
    },
  },
  CTA_DISTRIBUTION_ADP_STAGING: {
    id: '1004195310',
    name: 'CTA Distribution Ad Details Staging',
    key: 'cta-distribution-adp-staging',
    variations: {
      ORIGINAL: { key: 'original', id: '1004459229' },
      VARIANT_1: { key: 'variation-1', id: '1004459230' },
      VARIANT_2: { key: 'variation-2', id: '1004459241' },
    },
  },
  CTA_DISTRIBUTION_ADP: {
    id: '1004196011',
    name: 'CTA Distribution Ad Details',
    key: 'cta-distribution-adp',
    variations: {
      ORIGINAL: { key: 'original', id: '1004460867' },
      VARIANT_1: { key: 'variation-1', id: '1004460868' },
      VARIANT_2: { key: 'variation-2', id: '1004460869' },
    },
  },
  GALLERY_INTERACTIONS_EXPERIMENT: {
    id: '1004197274',
    name: 'Gallery Interaction Staging',
    key: GALLERY_INTERACTIONS_EXPERIMENT_KEY,
    variations: {
      ORIGINAL: { key: 'original', id: '1004463763' },
      VARIANT_1: { key: 'variation-1', id: '1004463764' },
      VARIANT_2: { key: 'variation-2', id: '1004463765' },
    },
  },
} as const;

export type ExperimentKey =
  | (typeof EXPERIMENTS)[keyof typeof EXPERIMENTS]['key'];
